const prefix = 'iam-groups';

const SET_ALL_GROUPS = `${prefix}/SET_ALL_GROUPS`;

const SET_TOTAL = `${prefix}/SET_TOTAL`;

const SET_LOADING = `${prefix}/SET_LOADING`;

const RESET = `${prefix}/RESET`;

export { SET_ALL_GROUPS, SET_TOTAL, RESET, SET_LOADING };
